import { normalizeCountryCodeForClientSDK } from '@sxm-de/dev-kits/web-sdk/utils';
import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { getOffersNew } from '@sxm-de/dev-kits/web-sdk/domains/offers';

interface OfferHasPartnerProductPayload {
    promoCode?: string;
    countryCode?: 'us' | 'US' | 'ca' | 'CA';
    serviceType: 'Automotive' | 'Streaming';
}

export type OfferHasPartnerProductFn = (
    payload: OfferHasPartnerProductPayload,
) => Promise<boolean>;

export function offerHasPartnerProductFn({
    dependencies,
    countryCodeDefault,
}: DomainInitPayload): OfferHasPartnerProductFn {
    return async (payload) => {
        const countryCode = normalizeCountryCodeForClientSDK(
            payload.countryCode || countryCodeDefault,
        );

        try {
            const offerData = await getOffersNew(
                {
                    ...(payload.promoCode
                        ? { promoCode: payload.promoCode }
                        : {}),
                    country: normalizeCountryCodeForClientSDK(countryCode),
                    serviceType: payload.serviceType,
                },
                dependencies,
            );
            if (!offerData.offers.length) {
                return false;
            }
            const offer = offerData.offers[0].offer;
            return offer.products.some(
                (product) => product.productType.partner,
            );
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
